import { Handle, Position, NodeProps, NodeToolbar } from "@xyflow/react";

import { FlagIcon } from "@/components/icons";
import { EndNodeType } from "@/types/flow";
import NodeToolMenu from "../../node-tool";
import { useFlowSelection } from "@/hooks/useFlowBuilder";
import { NodeEventFrame } from "../node-event-frame";

const EndNode = ({ id, selected = false, data }: NodeProps<EndNodeType>) => {
  const { selectedNodeId } = useFlowSelection();
  const isSelected = selected || selectedNodeId === id;
  return (
    <div className="w-[280px] flex justify-center">
      <NodeToolMenu
        toolbarProps={{ nodeId: id }}
        node={{ id }}
        isVisible={isSelected}
        showDownButton={false}
      />
      <Handle
        type="target"
        position={Position.Top}
        className="invisible"
        id="top"
      />
      <NodeEventFrame
        events={data.events}
        selected={selected}
        bodyClassName="p-0 w-fit"
        className="border rounded-md border-stroke overflow-clip bg-white w-fit max-w-[280px]"
      >
        <div className="bg-white flex flex-row gap-3 items-center justify-start px-5 py-3 relative rounded-md w-32 h-14">
          <div className="relative shrink-0 size-4">
            <FlagIcon className="block max-w-none size-full text-[#4a607e]" />
          </div>
          <div className="font-medium leading-[0] not-italic relative shrink-0 text-[#4a607e] text-[12px] text-left text-nowrap">
            <p className="block leading-[24px] whitespace-pre">End Point</p>
          </div>
        </div>
      </NodeEventFrame>
    </div>
  );
};

export default EndNode;
